import { useContext } from 'react';
import { BreakpointContext } from './BreakpointContext';
import { Breakpoint } from './breakpoints';

export function useBreakpoint(): Breakpoint {
    return useContext(BreakpointContext);
}
